import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'

export const style = css`
  :host {
    display: contents;
  }

  .product-options {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
  }

  cse-checkbox {
    --cse-checkbox-gap: 0;
  }

  .options {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
  }

  .option {
    align-items: start;
    column-gap: ${csSpacing.spacing06};
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    row-gap: ${csSpacing.spacing05};
    width: 100%;

    @media (min-width: ${SCREENS.small}) {
      grid-template-columns: auto minmax(0, 1fr) auto;
    }
  }

  .option-quantity {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing02};
    grid-column: 2;
    justify-self: end;

    @media (min-width: ${SCREENS.small}) {
      grid-column: 3;
    }
  }

  cse-divider {
    grid-column: 1 / -1;
  }

  .option-calculation {
    align-items: baseline;
    display: flex;
    gap: ${csSpacing.spacing06};
    grid-column: 2 / -1;
    justify-content: space-between;
  }

  .option-total {
    flex: none;
  }
`
